import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'phoneNumberFormat',
})
export class PhoneNumberFormat implements PipeTransform {
  transform(value: any, format: string) {
    let phNo = value ? ('' + value).match(/\d/g).join('') : '';
    let formatHash = format ? format.match(/#/g).join('') : '';
    if (formatHash.length > 0 && phNo.length == formatHash.length) {
      phNo.split('').forEach((n) => {
        format = format.replace('#', n);
      });
      return format;
    }
    return value;
  }
}
